import { useSelector } from 'react-redux'
import { StepId } from '@feedyou-ai/feedbot-schema'

import { ssmlValidationResultForIdSelector } from '../selectors'

export function useSsmlValidationResultForStepId(stepId?: StepId) {
  return useSelector(ssmlValidationResultForIdSelector('live', stepId!))
}
